import { render, staticRenderFns } from "./VendorBooth.vue?vue&type=template&id=ae3a5418&"
import script from "./VendorBooth.vue?vue&type=script&lang=js&"
export * from "./VendorBooth.vue?vue&type=script&lang=js&"
import style0 from "./VendorBooth.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports